export function initPort(app) {
  var modal = null;

  document.onclick = function(e) {
    checkClickedOutside(e.target);
  };

  document.onkeyup = function(e) {
    checkClickedOutside(e.target);
  };

  app.ports.set && app.ports.set.subscribe(set);

  app.ports.clear && app.ports.clear.subscribe(clear);

  function checkClickedOutside(target) {
    app.ports.clickedOutside &&
      modal &&
      !hasClickedInside(target, modal) &&
      clear(modal.id);
  }

  function hasClickedInside(target, modal) {
    var node = document.getElementById(modal.id);
    return (
      node &&
      (node === target ||
        node.contains(target) ||
        (modal.omittedIds.length > 0 &&
          modal.omittedIds.filter(function(id) {
            return hasClickedInside(target, { id: id, omittedIds: [] });
          }).length > 0))
    );
  }

  function set(request) {
    setTimeout(function() {
      if (modal) {
        if (modal.id !== request.id) {
          app.ports.clickedOutside && app.ports.clickedOutside.send(modal.id);
          modal = request;
        }
      } else {
        modal = request;
      }
    });
  }

  function clear(id) {
    if (id) {
      if (modal && modal.id === id) {
        app.ports.clickedOutside && app.ports.clickedOutside.send(id);
        modal = null;
      }
    } else {
      modal &&
        app.ports.clickedOutside &&
        app.ports.clickedOutside.send(modal.id);
      modal = null;
    }
  }
}
